/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'

/* COMPONENTS */
import { Spinner } from '../../ui'

/* STORE */
import { sendFeedback, setShowFeedbackModal } from '../../../store/maya/actions'

/* STYLES */
import {
  ModalOverlay,
  ModalContent,
  FeecbackMessage,
  CloseIcon,
  FeedbackOptions,
  FeedbackOption,
} from './style'

/* UTILS/CONSTANTS */
import { createLoadingSelector, getTranslations } from '../../../utils'
import { SEND_FEEDBACK } from '../../../store/maya/constants.js'

/* ASSETS */

const FeedbackModal = ({
  isSavingFeedback,
  language,
  top,
  bottom,
  sendFeedback,
  setShowFeedbackModal,
  mobileView = true,
  onFeedbackSubmit,
}) => {
  const [hasSubmitted, setHasSubmitted] = useState(false)

  useEffect(() => {
    if (!isSavingFeedback && hasSubmitted) {
      setShowFeedbackModal(false)
    }
  }, [isSavingFeedback, hasSubmitted, setShowFeedbackModal])

  const handleFeedback = rating => {
    setHasSubmitted(true)
    sendFeedback(rating)
  }

  return (
    <ModalOverlay top={top} bottom={bottom}>
      <ModalContent onClick={e => e.stopPropagation()} id='modal-content'>
        {isSavingFeedback ? (
          <div
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: '0.8',
              zIndex: '100',
              position: 'absolute',
            }}
          >
            {' '}
            <Spinner isBasic={false} interval={10000} messages={[]} />
          </div>
        ) : null}
        <div style={{ visibility: isSavingFeedback ? 'hidden' : 'visible' }}>
          <CloseIcon
            onClick={() => {
              setShowFeedbackModal(false)
            }}
          />
          <FeecbackMessage mobileView={mobileView}>
            {getTranslations('feedback_text')}
          </FeecbackMessage>
          <FeedbackOptions mobileView={mobileView}>
            <FeedbackOption alt='angry' onClick={() => handleFeedback(1)}>
              &#128544;
            </FeedbackOption>
            <FeedbackOption
              alt='disappointed'
              onClick={() => handleFeedback(2)}
            >
              &#128542;
            </FeedbackOption>
            <FeedbackOption alt='neutral' onClick={() => handleFeedback(3)}>
              &#128528;
            </FeedbackOption>
            <FeedbackOption alt='positive' onClick={() => handleFeedback(4)}>
              &#128522;
            </FeedbackOption>
            <FeedbackOption alt='love' onClick={() => handleFeedback(5)}>
              &#128525;
            </FeedbackOption>
          </FeedbackOptions>
        </div>
      </ModalContent>
    </ModalOverlay>
  )
}

const loadingSelector = createLoadingSelector([SEND_FEEDBACK])

const mapStateToProps = state => ({
  isSavingFeedback: loadingSelector(state.loading),
  language: state.general.language,
})

const mapDispatchToProps = dispatch => ({
  sendFeedback: rating => dispatch(sendFeedback(rating)),
  setShowFeedbackModal: show => dispatch(setShowFeedbackModal(show)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackModal)
